module.exports = __webpack_public_path__ + "static/NOUR-b4fe734fcec76afb653dcc3c915167ac.jpg";